import { useInfiniteQuery } from 'react-query';
import { BattleListSortOrder, BattleSortBy, BattleStatus } from 'models/battles/Battle';
import BattlesService from 'services/battles/BattlesService';

export type UseGetBattleListProps = {
	'services.battlesService': BattlesService;
	statuses?: BattleStatus[];
	sortBy?: BattleSortBy;
	sortOrder?: BattleListSortOrder;
};

const countPerPage = 18;
export const getBattleListQueryKey = 'battles-my-battle-list';

export type UseGetBattleListQueryReturn = ReturnType<typeof useGetBattleList>;

export const useGetBattleList = (props: UseGetBattleListProps) => {
	const battlesService = props['services.battlesService'];

	return useInfiniteQuery({
		queryKey: [getBattleListQueryKey, props.statuses, props.sortBy, props.sortOrder],
		queryFn: ({ pageParam }) =>
			battlesService.fetchBattleList(countPerPage, pageParam, props.statuses, props.sortBy, props.sortOrder),
		getNextPageParam: (lastPage, pages) =>
			Math.ceil(lastPage.count / countPerPage) > pages.length ? pages.length + 1 : undefined,
		cacheTime: 0,
	});
};

export default useGetBattleList;
